<ng-container *ngIf="permConfig.isViewAllowed">
    <div class="container-fluid">
        <app-page-title title="Discount"></app-page-title>
        <form [formGroup]="discountForm">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">

                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="discountType">Discount Type
                                            <span class="mandatory">*</span>
                                        </label>
                                        <ng-select id="discountType" placeholder="Select" [items]="discountTypeList"
                                            [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlDiscountType"
                                            (change)="onChangeDiscountType()"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || discountForm.get('ddlDiscountType').touched) && discountForm.get('ddlDiscountType').errors}" >
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || discountForm.get('ddlDiscountType').touched) && discountForm.get('ddlDiscountType').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="discountForm.get('ddlDiscountType').errors.required">Discount
                                                Type is Required</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2" *ngIf="isCategoryVisible">
                                    <div class="mb-2">
                                        <label for="categoryType">Category <span class="mandatory">*</span></label>
                                        <ng-select id="categoryType" placeholder="Select" [items]="categoryList"
                                            [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlCategoryType"
                                            (change)="onChangeCategory()"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || discountForm.get('ddlCategoryType').touched) && discountForm.get('ddlCategoryType').errors}" >
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || discountForm.get('ddlCategoryType').touched) && discountForm.get('ddlCategoryType').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="discountForm.get('ddlCategoryType').errors.required">Discount
                                                Type is Required</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2" *ngIf="isCustomerVisible">
                                    <div class="mb-2">
                                        <label for="customer">Customer <span class="mandatory">*</span></label>
                                        <ng-select id="customer" placeholder="Select" [items]="customerList"
                                            bindLabel="name" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                            formControlName="ddlCustomer"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || discountForm.get('ddlCustomer').touched) && discountForm.get('ddlCustomer').errors}" >
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || discountForm.get('ddlCustomer').touched) && discountForm.get('ddlCustomer').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="discountForm.get('ddlCustomer').errors.required">Customer
                                                is Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="fromDate" class="form-label">From Date <span
                                                class="mandatory">*</span></label>
                                        <input id="fromDate" class="form-control form-control-sm" type="date"
                                            formControlName="txtFromDate"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || discountForm.get('txtFromDate').touched) && discountForm.get('txtFromDate').errors}" >
                                        <div *ngIf="(isFormSubmitted || discountForm.get('txtFromDate').touched) && discountForm.get('txtFromDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="discountForm.get('txtFromDate').errors.required">Date is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="toDate" class="form-label">To Date <span
                                                class="mandatory">*</span></label>
                                        <input id="toDate" class="form-control form-control-sm" type="date"
                                            formControlName="txtToDate"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || discountForm.get('txtToDate').touched) && discountForm.get('txtToDate').errors}" >
                                        <div *ngIf="(isFormSubmitted || discountForm.get('txtToDate').touched) && discountForm.get('txtToDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="discountForm.get('txtToDate').errors.required">Date is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" *ngIf="showBands">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="bands" class="form-label">Bands <span
                                                class="mandatory">*</span></label>
                                        <ng-select id="bands" [items]="bandsList" placeholder="Select"
                                            [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlBands"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || discountForm.get('ddlBands').touched) && discountForm.get('ddlBands').errors}" >
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || discountForm.get('ddlBands').touched) && discountForm.get('ddlBands').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="discountForm.get('ddlBands').errors.required">Rate
                                                Band is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" *ngIf="showAccordingDiscountOnAmount">
                                <div class="col-md-1">
                                    <div class="mb-3">
                                        <label for="fuel" class="form-label">Fuel</label>
                                        <div class="form-check form-switch form-switch-md">
                                            <input type="checkbox" class="form-check-input"
                                                formControlName="switchFuel" >
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-1">
                                    <div class="mb-3">
                                        <label for="freight" class="form-label">Freight</label>
                                        <div class="form-check form-switch form-switch-md mb-2">
                                            <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                                formControlName="switchFreight" >
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-1">
                                    <div class="mb-3">
                                        <label for="othercharges" class="form-label">Other Charges</label>
                                        <div class="form-check form-switch form-switch-md mb-2">
                                            <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                                formControlName="switchOtherCharges" >
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" *ngIf="showAccordingDiscountOnWeight">
                                <div class="col-md-1">
                                    <div class="mb-3">
                                        <label for="volumetrivweight" class="form-label">Volumetric Weight</label>
                                        <div class="form-check form-switch form-switch-md">
                                            <input type="checkbox" class="form-check-input"
                                                formControlName="switchVolumetricWeight" >
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4">
                                    <label class="form-label"></label>
                                    <div class="input-group">
                                        <input type="file" class="form-control form-control-sm" accept=".xlsx,.xls"
                                            formControlName="fileControl" (change)="onChangeFileSelect($event)"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || discountForm.get('fileControl').touched) && discountForm.get('fileControl').errors}" >
                                        <button type="button" class="btn btn-primary btn-sm d-flex"
                                            (click)="uploadDiscount()" >
                                            <i class="bx bx-upload font-size-15 me-1"></i> Upload
                                        </button>
                                        <div *ngIf="(isFormSubmitted || discountForm.get('fileControl').touched) && discountForm.get('fileControl').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="discountForm.get('fileControl').errors.required">Select file
                                                to upload</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Discount Periods</div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                class="ag-theme-balham" [rowData]="discountPeriodData" [columnDefs]="columnDefsPeriod"
                                [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                [suppressMenuHide]="true" [pagination]="true" (gridReady)="onGridReadyPeriod($event)"
                                [gridOptions]="gridOptionsPeriod" [rowSelection]="'single'">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Discount Details</div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                class="ag-theme-balham" [rowData]="discountInfoData" [columnDefs]="columnDefs"
                                [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                [suppressMenuHide]="true" [pagination]="true" (gridReady)="onGridReady($event)"
                                [gridOptions]="gridOptions" [rowSelection]="'single'">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>